import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { Condition } from 'Component/others';
import Tooltip from 'UiKit/tooltip';
import { TextMedium, TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const TitleColumn = ({ values }) => {
  const { t } = useTranslation('desktop-brief-live');
  const { title, isSpecialEvent, assignedHosts } = values;

  const transformedAssignedHosts = assignedHosts?.join(', ');

  return (
    <Box className={styles['title-column__container']}>
      <TextRegular>{title}</TextRegular>
      <Condition statement={isSpecialEvent}>
        <Box className={styles['title-column__special-event-container']}>
          <TextMedium fontSize="var(--font-body3)">{t('tableTalkingPoint.specialEvent')} | </TextMedium>
          <Tooltip align="left" label={<Box maxWidth="196px">{transformedAssignedHosts}</Box>} className={styles['title-column__hosts-tooltip']}>
            <Box className={styles['title-column__assigned-hosts']}>{transformedAssignedHosts}</Box>
          </Tooltip>
        </Box>
      </Condition>
    </Box>
  );
};

export default TitleColumn;
